import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72390c3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "group-name" }
const _hoisted_3 = { class: "item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_oio_input = _resolveComponent("oio-input")!
  const _component_OioButton = _resolveComponent("OioButton")!
  const _component_oio_form_item = _resolveComponent("oio-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_oio_form = _resolveComponent("oio-form")!

  return (_ctx.cateAttrs.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_oio_form, {
          ref: "formRef",
          layout: "vertical",
          data: _ctx.formData
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (groupData, groupName, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(groupName), 1),
                _createVNode(_component_a_row, { gutter: 24 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupData, (value, key, index) => {
                      return (_openBlock(), _createBlock(_component_a_col, {
                        span: 12,
                        key: index
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_oio_form_item, {
                              name: key + '',
                              required: _ctx.curAttr(key + '')?.isRequired,
                              label: key + '',
                              style: {"width":"400px"},
                              validateTrigger: "blur"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.curAttr(key + '')?.isSelect)
                                  ? (_openBlock(), _createBlock(_component_a_select, {
                                      key: 0,
                                      class: "oio-select",
                                      "dropdown-class-name": "oio-select-dropdown",
                                      getPopupContainer: (triggerNode) => triggerNode.parentNode,
                                      value: _ctx.data[groupName][key + ''],
                                      "onUpdate:value": ($event: any) => ((_ctx.data[groupName][key + '']) = $event),
                                      options: _ctx.curAttr(key + '')?.options ?? [],
                                      mode: _ctx.curAttr(key + '')?.isMulti ? 'multiple' : undefined,
                                      "show-search": _ctx.curAttr(key + '')?.isSearch,
                                      allowClear: ""
                                    }, null, 8, ["getPopupContainer", "value", "onUpdate:value", "options", "mode", "show-search"]))
                                  : (_openBlock(), _createBlock(_component_oio_input, {
                                      key: 1,
                                      value: _ctx.customData[key + ''],
                                      "onUpdate:value": ($event: any) => ((_ctx.customData[key + '']) = $event),
                                      style: {"width":"280px"},
                                      placeholder: "请输入自定义值"
                                    }, null, 8, ["value", "onUpdate:value"])),
                                (_ctx.curAttr(key + '')?.isExtend)
                                  ? (_openBlock(), _createBlock(_component_OioButton, {
                                      key: 2,
                                      type: "link",
                                      onClick: ($event: any) => (_ctx.curAttr(key + '').isSelect = !_ctx.curAttr(key + '').isSelect),
                                      style: {"margin-left":"12px"}
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.curAttr(key + '')?.isSelect ? '+自定义属性值' : '+选择属性值'), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["name", "required", "label"])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 2
                }, 1024)
              ], 64))
            }), 128))
          ]),
          _: 1
        }, 8, ["data"])
      ]))
    : _createCommentVNode("", true)
}